import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.element.addEventListener("paste", e => this.pasteCode(e));
        this.element.addEventListener("input", e => this.moveToNextTextInput(e));
    }

    async pasteCode(e) {
        const textInputs = Array.from(this.element.querySelectorAll("input[type=text]"));

        if (textInputs.indexOf(e.target) === 0 && e.target.value === "") {
            e.preventDefault();
            const codeParts = e.clipboardData.getData("text/plain")
                .replace(/-/g, "")
                .match(/.{1,4}/g);

            for (let i = 0; i < textInputs.length; i++) {
                if (textInputs[i].value === "") {
                    textInputs[i].value = codeParts[i];
                } else {
                    break;
                }
            }
        }
    }

    moveToNextTextInput(e) {
        if (e.target.value.length === e.target.maxLength) {
            const textInputs = Array.from(this.element.querySelectorAll("input[type=text]"));
            const nextTextInput = textInputs[textInputs.indexOf(e.target) + 1];

            if (nextTextInput) {
                nextTextInput.focus();
            }
        }
    }
}